<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('common_words.profile_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('common_words.admin')}...`"
        >
        </fg-input>
      </div>
      <div class="col-6">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_type_user') }}:</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select bus-rels shadow-sm required-type"
            v-model="model.type"
            filterable
            :placeholder="$t('common_words.select_type_profile')"
          >
            <el-option
              v-if="validateBusiness()"
              class="select-primary"
              value="super administrador"
              :label="$t('common_words.super_admin')"
            ></el-option>
            <el-option
              class="select-primary"
              value="administrador"
              :label="$t('common_words.admin')"
            ></el-option>
            <el-option
              class="select-primary"
              value="usuario"
              :label="$t('common_words.normal_user')"
            ></el-option>
            <el-option
              v-if="validateBusiness()"
              class="select-primary"
              value="visitante"
              :label="$t('common_words.visiting_user')"
            ></el-option>
            <el-option
              v-if="validateBusiness()"
              class="select-primary"
              value="demo"
              :label="$t('common_words.demo_user')"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_companies') }}: *</label
          >
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.businesses_ids', businesses)"
            clearable
            filterable
            multiple
            class="select-primary custom-width-select shadow-sm required-business"
            size="large"
            v-model="model.businesses_ids"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import SweetAlert from 'src/class/Alerts';
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  data() {
    return {
      model: {
        name: null,
        businesses_ids: null,
        type: 'usuario',
      },
      modelValidations: {
        name: {
          required: true,
        },
      },
      businesses: [],
    };
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },

    validateBusiness() {
      let response = false;
      this.$store.state.auth.user.business.forEach((element) => {
        if (element.id == 1) {
          response = true;
        }
      });
      return response;
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          let others = [];
          this.businesses.forEach((item) => {
            this.model.businesses_ids.forEach((element) => {
              if (element == item.id) {
                others.push(item.name);
              }
            });
          });

          this.$emit('fillRoleForm', 'firstStep', {
            name_businesses: others,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;
          if (!isset(this.model.type)) {
            return this.validationInputsRequired('type');
          } else {
            if (!isset(this.model.businesses_ids)) {
              return this.validationInputsRequired('business');
            } else return true;
          }
        });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
          this.showHideLoading();
        });
    } else this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = editForm;

      this.model.businesses_ids = [];
      editForm.business.forEach((item) => {
        this.model.businesses_ids.push(item.id);
      });
    }
  },
};
</script>
<style></style>
